import { Box, Flex, Input, Button } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import { FC, useState } from 'react'
import NextImage from 'next/image'
import { signin, signup } from '../lib/mutations'

const AuthForm: FC<{ mode: 'signin' | 'signup' }> = ({ mode }) => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const router = useRouter()

  const handleOnSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    if (mode === 'signup') {
      await signup({ email, password, firstName, lastName })
    } else {
      await signin({ email, password })
    }
    setIsLoading(false)
    router.push('/')
  }

  const handleOnFillForm = () => {
    setEmail('user@test.com')
    setPassword('password')
  }

  return (
    <Box height="100vh" width="100vw" bg="black" color="white">
      <Flex
        justify="center"
        align="center"
        height="100px"
        borderBottom="white 1px solid"
      >
        <NextImage src="/logo.svg" height={60} width={120} />
      </Flex>
      <Flex justify="center" align="center" height="calc(100vh - 100px)">
        <Box padding="50px" bg="gray.900" borderRadius="6px">
          <form onSubmit={handleOnSubmit}>
            {mode === 'signup' && (
              <>
                <Input
                  placeholder="first name"
                  type="text"
                  marginBottom="10px"
                  onChange={(e) => setFirstName(e.target.value)}
                />
                <Input
                  placeholder="last name"
                  type="text"
                  marginBottom="10px"
                  onChange={(e) => setLastName(e.target.value)}
                />
              </>
            )}
            <Input
              placeholder="email"
              type="email"
              marginBottom="10px"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Input
              placeholder="password"
              type="password"
              marginBottom="10px"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {mode === 'signin' && (
              <Box
                cursor="pointer"
                fontSize="sm"
                sx={{
                  '&:hover': {
                    color: 'blue.800',
                  },
                }}
                onClick={handleOnFillForm}
              >
                or fill the form
              </Box>
            )}
            <Button
              type="submit"
              bg="green.500"
              isLoading={isLoading}
              sx={{
                '&:hover': {
                  bg: 'teal.800',
                },
              }}
              marginTop="20px"
            >
              {mode === 'signin' ? 'Sign in' : 'Sign up'}
            </Button>
          </form>
        </Box>
      </Flex>
    </Box>
  )
}

export default AuthForm
